(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-cards-slider"] && !window.DesignMode) return;
  try {
    
(function(){
  var root = document.getElementById('FeatureCards-{{ section.id }}');
  if(!root) return;
  var viewport = root.querySelector('.fc__viewport');
  var list = root.querySelector('.fc__list');
  var dotsWrap = root.querySelector('.fc__dots');

  function buildDots(){
    if(!viewport || !dotsWrap) return;
    if(viewport.getAttribute('data-has-dots') !== 'true') return;
    dotsWrap.innerHTML = '';
    var items = list ? list.children : [];
    for(var i=0;i<items.length;i++){
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'fc__dot';
      dot.setAttribute('aria-current', i===0 ? 'true' : 'false');
      (function(index){
        dot.addEventListener('click', function(){
          var card = items[index];
          if(card){ card.scrollIntoView({behavior:'smooth', inline:'start', block:'nearest'}); }
        });
      })(i);
      dotsWrap.appendChild(dot);
    }
  }

  function updateDots(){
    if(!dotsWrap || !list) return;
    var dots = dotsWrap.querySelectorAll('.fc__dot');
    if(!dots.length) return;
    var children = Array.prototype.slice.call(list.children);
    var nearestIndex = 0, min = Infinity;
    var rectList = list.getBoundingClientRect();
    children.forEach(function(el, idx){
      var r = el.getBoundingClientRect();
      var delta = Math.abs((r.left + r.width*0.5) - (rectList.left + rectList.width*0.5));
      if(delta < min){ min = delta; nearestIndex = idx; }
    });
    dots.forEach(function(d, i){ d.setAttribute('aria-current', i===nearestIndex ? 'true' : 'false'); });
  }

  var prev = root.querySelector('.fc__arrow--prev');
  var next = root.querySelector('.fc__arrow--next');
  function scrollByOne(dir){
    var width = list.getBoundingClientRect().width;
    list.scrollBy({left: dir * (width * 0.86), behavior: 'smooth'});
  }
  if(prev) prev.addEventListener('click', function(){ scrollByOne(-1); });
  if(next) next.addEventListener('click', function(){ scrollByOne(1); });

  if(list){
    buildDots();
    list.addEventListener('scroll', function(){ window.requestAnimationFrame(updateDots); }, {passive:true});
    window.addEventListener('resize', function(){ window.requestAnimationFrame(updateDots); });
    updateDots();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
